import {Optimization} from './types';

export const MockData: Optimization[] = [
  {
    id: 1,
    week: 16,
    year: 2021,
    teamId: 20,
    errorKey: 'failed',
  },
];
